module.exports = __webpack_public_path__ + "media/images/hero/hero1-house-background-6d9f952f6a6c7546d9a80b2f7f82ccd6.svg";